export interface ICustomEmoji {
  customEmojiId: string;
  /** `null` — обычной замены нет, элемент нельзя вставить */
  fallbackEmoji: string | null;
  /** `null` — картинки нет, вместо неё показывается `fallbackEmoji` */
  previewUrl: string | null;
}

export interface ICustomEmojiSet {
  /** Имя набора в Telegram; им же набор обновляется и удаляется */
  setName: string;
  title: string;
  dateUpdated: Date;
  emojis: ICustomEmoji[];
}

/** Какой текст подсказки показывается у вкладки «Кастомные» */
export enum CustomEmojiHintKind {
  /** Диалог в Telegram, через этого бота ещё не отправляли custom emoji */
  telegramUnknown = 'telegramUnknown',
  /** Диалог в Telegram, последняя отправка показала, что возможности нет */
  telegramUnsupported = 'telegramUnsupported',
  /** Диалог в Telegram, последняя отправка прошла с custom emoji */
  telegramSupported = 'telegramSupported',
  /** Диалог в другом мессенджере */
  otherMessenger = 'otherMessenger',
  /** Редактор блока сценария: диалога нет */
  scenarioBlock = 'scenarioBlock',
  /** Редактор блока сценария с включённой разметкой Markdown */
  scenarioBlockMarkdown = 'scenarioBlockMarkdown'
}

/**
 * Наборов на страницу. Серверный предел страницы — 50 наборов, столько же
 * максимум в проекте, но страницу держим меньше: в наборе до 200 элементов.
 */
export const CUSTOM_EMOJI_SETS_PAGE_SIZE = 20;

/** Единственный тег, допустимый в `message_markup` и в `params.markup` блока */
export const CUSTOM_EMOJI_TAG = 'tg-emoji';

/** Атрибут тега с идентификатором custom emoji — только из цифр */
export const CUSTOM_EMOJI_ID_ATTRIBUTE = 'emoji-id';

/**
 * Класс картинки, которой на месте тега рисуется custom emoji. Разметку
 * собирают и редактор, и история, а размеры задаёт каждая из них по своей
 * строке, поэтому общее у них только имя класса.
 */
export const CUSTOM_EMOJI_IMAGE_CLASS = 'custom-emoji-image';

/**
 * Идентификаторов в одном запросе картинок. Серверный предел — 100, и видимых
 * сообщений чата с запасом хватает на одну пачку.
 */
export const CUSTOM_EMOJI_PREVIEWS_REQUEST_LIMIT = 100;

/** Пауза между автоматическими обновлениями набора. */
export const CUSTOM_EMOJI_REFRESH_DELAY_MS = 1500;

/** Максимальное число запросов обновления в одном цикле. */
export const CUSTOM_EMOJI_REFRESH_MAX_ATTEMPTS = 15;

/** Число последовательных проходов без уменьшения числа preview без картинки. */
export const CUSTOM_EMOJI_REFRESH_MAX_NO_PROGRESS_ATTEMPTS = 2;
